import React, { Component } from 'react';

import { WhoWeAre } from '../WhoWeAre';
import { EmailCapture } from '../EmailCapture';

import {
	Grid,
	Divider,
	Segment,
	Image,
	Container,
	Header
} from 'semantic-ui-react';

import './About.css';

export class About extends Component 
{
	render() 
	{	
		return (
			<div>
				<div className='about-header ui vertical masthead'>
					<div className='ui center aligned text container'>
						<Image src={this.props.logo}/>
					</div>
				</div>
				<Grid>
					<Grid.Row>
						<Grid.Column width={16}>
							<Divider hidden />
							<WhoWeAre headerAlign='left' />
						</Grid.Column>
					</Grid.Row>
					<Grid.Row>
						<Grid.Column width={16}>
							<Container>
								<Segment basic size='large'>
									<Header size='huge' textAlign='left'>
										Our Story
									</Header>
									<p>Captivate Games was founded by Mike Dwyer and Tommy Leung in 2017. Mike and Tommy are avid gamers who have spent the majority of their professional careers in the games industry. They worked together as part of the founding engineering team at Rising Tide Games in New York City. Rising Tide Games created the social casino games <i>Black Diamond Casino</i> and <i>Vegas Diamond Slots</i>. The company was eventually acquired by Zynga.</p>

									<p>After a few years in social casino, they were ready to work on new genres and ideas.</p>

									<p>Mike had a game idea that he's wanted to develop for years but haven't had the chance. Tommy has dreamed of starting a game company since he was a teenager but never pulled the trigger. The planets aligned as their time at Zynga came to an end. The founders decided to start a company modeled after their role models in the games industry.</p>

									<p>The company would create fun and original games. Fast following lacks a certain amount of soul. It would take all the modern techniques in developing games and running a games business but use it in a responsible manner. Providing players with a great experience would be at the forefront.</p>

									<p>It may be grandiose but Mike and Tommy wanted to improve on the good ideas while the shedding the bad ideas from the companies they've worked for and the industry at large. It will be no small task but that's what they believe a modern games company should be so they are going to make it a reality.</p>

									<p>And that's how Captivate Games was born.</p>
								</Segment>
							</Container>
						</Grid.Column>
					</Grid.Row>
					<Grid.Row>
						<Grid.Column width={16}>
							<EmailCapture />
						</Grid.Column>
					</Grid.Row>
				</Grid>
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/About/About.js